// extracted by mini-css-extract-plugin
export var footer = "mobileMenu-module--footer--bbf3e";
export var linksWrapper = "mobileMenu-module--linksWrapper--10987";
export var wrapper = "mobileMenu-module--wrapper--423e7";